module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sdk-advert"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("SDK广告管理")]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("当前SDK广告投放状态：" + _vm._s(_vm.isOpen ? '已开启' : '已关闭'))]), _vm._v(" "), (!_vm.showTimeInput && _vm.isOpen) ? _c('div', {
    staticClass: "time-box"
  }, [_c('span', [_vm._v("开放时间段：")]), _vm._v(" "), (_vm.startTime) ? _c('span', [_vm._v(_vm._s(_vm.startTime) + " 至 " + _vm._s(_vm.endTime))]) : _c('span', [_vm._v("全天")]), _vm._v(" "), _c('span', {
    staticClass: "btn-edit",
    on: {
      "click": function($event) {
        _vm.showTimeInput = true
      }
    }
  }, [_vm._v("修改")])]) : _vm._e(), _vm._v(" "), (_vm.showTimeInput || !_vm.isOpen) ? _c('div', {
    staticClass: "time-box"
  }, [_c('span', [_vm._v("开放时间段：")]), _vm._v(" "), _c('el-select', {
    staticClass: "my-time",
    attrs: {
      "clearable": "",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }, _vm._l((_vm.startTimeList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v("\n            至\n            "), _c('el-select', {
    staticClass: "my-time",
    attrs: {
      "clearable": "",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }, _vm._l((_vm.startTimeList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), (_vm.isOpen) ? _c('span', {
    staticClass: "btn-edit",
    on: {
      "click": _vm.cancleSaveTime
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isOpen) ? _c('span', {
    staticClass: "btn-edit",
    on: {
      "click": _vm.saveTime
    }
  }, [_vm._v("保存")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "screen-box"
  }, [_c('span', [_vm._v("是否全屏：")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.screenType),
      callback: function($$v) {
        _vm.screenType = $$v
      },
      expression: "screenType"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.screenType),
      callback: function($$v) {
        _vm.screenType = $$v
      },
      expression: "screenType"
    }
  }, [_vm._v("否")]), _vm._v(" "), (_vm.isOpen) ? _c('span', {
    staticClass: "btn-edit",
    on: {
      "click": _vm.saveScreenType
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toChangeOpening
    }
  }, [_vm._v(_vm._s(_vm.isOpen ? '一键关停' : '一键开启'))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bbcd438!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/sdkAdvert/sdkAdvert.vue
// module id = 959
// module chunks = 0